const capitalizeFirst = (value = '') => {
  const text = String(value || '').trim();
  if (!text) {
    return '';
  }

  return `${text[0].toUpperCase()}${text.slice(1)}`;
};

const normalizeFoodTitleText = (value = '') => String(value || '')
  .replace(/\s+/g, ' ')
  .trim()
  .toLowerCase();

const FOOD_MEAL_TITLE_PATTERN = /\b(breakfast|lunch|dinner|snack|meal)\b/i;
const FOOD_FEW_BITES_TITLE_PATTERN = /\b(few bites|a few bites|only ate a few bites)\b/i;
const QUICK_FOOD_REFUSAL_TITLE_PATTERN = /\b(refused|did not eat|didn't eat|wouldn't eat|won't eat|not eating)\b/i;
const QUICK_FOOD_CONSUMPTION_TITLE_PATTERN = /\b(ate|eating|drank|drink|juice|milk|water|meal|snack|lunch|dinner|breakfast)\b/i;
const IMPORT_FOOD_REFUSAL_TITLE_PATTERN = /\b(refused|did not eat|didn't eat|wouldn't eat|won't eat|not eat|only ate a few bites|few bites)\b/i;
const IMPORT_FOOD_CONSUMPTION_TITLE_PATTERN = /\b(ate|eating|drank|drinking|had|had some)\b/i;
const IMPORT_FOOD_PORTION_TITLE_PATTERN = /\b(half|few bites|some|most|all|a little|part(?:ial)?|small amount)\b/i;

const getMealTitle = (text = '') => {
  const mealMatch = text.match(FOOD_MEAL_TITLE_PATTERN);
  return mealMatch ? capitalizeFirst(mealMatch[1].toLowerCase()) : 'Food';
};

const buildFewBitesTitle = (meal = 'Food') => `${meal} — few bites`;

const buildFoodEatenTitle = (meal = 'Food') => (
  meal === 'Food' ? 'Food eaten' : `${meal} eaten`
);

export const buildQuickNoteFoodTitle = (value = '') => {
  const text = normalizeFoodTitleText(value);
  if (!text) {
    return 'Food';
  }

  const meal = getMealTitle(text);

  if (FOOD_FEW_BITES_TITLE_PATTERN.test(text)) {
    return buildFewBitesTitle(meal);
  }

  if (QUICK_FOOD_REFUSAL_TITLE_PATTERN.test(text)) {
    return `${meal} refused`;
  }

  if (QUICK_FOOD_CONSUMPTION_TITLE_PATTERN.test(text)) {
    return buildFoodEatenTitle(meal);
  }

  return meal;
};

export const buildImportFoodHeadline = (value = '') => {
  const text = normalizeFoodTitleText(value);
  if (!text) {
    return 'Food';
  }

  const meal = getMealTitle(text);

  if (IMPORT_FOOD_REFUSAL_TITLE_PATTERN.test(text)) {
    if (/\bfew bites\b/i.test(text)) return buildFewBitesTitle(meal);
    return `${meal} refused`;
  }

  if (IMPORT_FOOD_CONSUMPTION_TITLE_PATTERN.test(text)) {
    const portionMatch = text.match(IMPORT_FOOD_PORTION_TITLE_PATTERN);
    if (portionMatch?.[1]) {
      const portion = portionMatch[1].toLowerCase();
      if (portion.includes('few bites')) return buildFewBitesTitle(meal);
      if (portion === 'half') return `${meal} — half eaten`;
      if (portion === 'most' || portion === 'all') return `${meal} — ${portion}`;
      return `${meal} — ${capitalizeFirst(portion)}`;
    }

    return buildFoodEatenTitle(meal);
  }

  return meal;
};
